import styles from "./Benefits.module.css";
import useHintStore from "../../store/hintStateStore";
import {BenefitsType, BenefitType, TextPart} from "../../interfaces/benefits/Benefits.type";
import {generateStyleClasses, styleHelper} from "../../helpers/commonFunctions";
import Benefit from "./Benefit";
import useAppStore from "../../store/AppStore";

export default function Benefits({
                                     item,
                                 }: {
    item: BenefitsType;
}) {

    const { setOpen } = useHintStore();
    const backgroundColor = item?.backgroundColor;
    const borderColor = item?.borderColor;
    const title = item?.title;
    const hint = item?.hint;
    const benefits = item?.benefitList;
    const privacyLine = item?.privacyLine;
    const contactUsLine = item?.contactUsLine;
    const { isDeviceMobile } = useAppStore();

    const hintHandler = (link: string) => {
        setOpen(true, link);
    };


    return (
        <div
            className={`vas-d-flex vas-extended-view vas-flex-column vas-align-items-center ${isDeviceMobile ? 'vas-px-3 vas-py-4' : 'vas-w-100'} ${styles.extended_view}`}
            style={{
                backgroundColor: backgroundColor,
                borderColor: borderColor
            }}>
            <div
                className={`vas-d-flex vas-flex-row vas-w-100 vas-align-items-center vas-justify-content-between vas-pb-1`}>
                <div className={`vas-d-flex vas-text-18 ${generateStyleClasses(title.style)}`}>{
                    title.text
                }</div>
                <div onClick={() => {hintHandler(hint?.link)}} className={`pointerCursor vas-d-flex vas-text-14 ${styleHelper({
                    color: hint.textColor
                })} ${generateStyleClasses(hint.style)}`}>{
                    hint.text
                }</div>
            </div>
            {
                benefits?.map((item: BenefitType, idx: number) => {
                    return <Benefit item={item} key={idx}/>;
                })
            }
            <div className={`vas-d-block vas-w-100 vas-pt-3 vas-pb-2`}>
                {
                    contactUsLine?.map((item: TextPart, idx: number) => {
                        return <div key={idx} style={styleHelper({
                            color: item.textColor
                        })} onClick={() => {
                            item?.link && hintHandler(item.link)
                        }} className={`vas-d-inline vas-me-1 ${item?.link ? 'pointerCursor' : ''} ${generateStyleClasses(item.style)}`}>{item.text}</div>
                    })
                }
            </div>
            <div className={`vas-d-block vas-w-100 vas-py-2`}>
            {
                privacyLine?.map((item: TextPart, idx: number) => {
                    return <div key={idx} style={styleHelper({
                        color: item.textColor
                    })} onClick={() => {
                        item?.link && hintHandler(item.link)
                    }} className={`vas-d-inline vas-me-1 ${item?.link ? 'pointerCursor' : ''} ${generateStyleClasses(item.style)}`}>{item.text}</div>
                })
            }
            </div>
        </div>
    );
}
